import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import BeaconFilterItem from '../../../models/BeaconFilterItem';
import stateInterProcs from '../../../state/stateInterProcs';
import stateFilterInterProc from '../../../state/stateFilterInterProc';

function QueryInterProc() {
  const [interProcs] = useRecoilState(stateInterProcs);
  const [filterInterProc, setFilterInterProc] =
    useRecoilState(stateFilterInterProc);
  const handleChange = useCallback(
    (
      event: React.SyntheticEvent<Element, Event>,
      value: BeaconFilterItem | null
    ) => {
      if (((value || {}).id || '') !== ((filterInterProc || {}).id || '')) {
        setFilterInterProc(value);
      }
    },
    [filterInterProc, setFilterInterProc]
  );

  if (0 < interProcs.length) {
    return (
      <Autocomplete
        fullWidth
        disablePortal
        options={interProcs}
        renderInput={(params) => <TextField {...params} margin="dense" />}
        value={filterInterProc}
        onChange={handleChange}
        size="small"
      />
    );
  } else {
    return <CircularProgress />;
  }
}

export default QueryInterProc;
